import clsx from 'clsx';
import { Formik } from 'formik';
import { memo, MouseEvent, useState } from 'react';
import { TableCustomCell } from '../../../../component/table/components/TableCustomCell';

type Props = {
	className?: string;
	disabled?: boolean;
	textValue?: string;
	textClassName?: string;
	editComponent: any;
	defaultEditable?: boolean;
};

const EditableCell = ({
	className,
	disabled,
	editComponent,
	textValue = '',
	textClassName,
	defaultEditable,
}: Props) => {
	const [enableEditing, setEnableEditing] = useState<boolean>(!!defaultEditable);

	return (
		<TableCustomCell
			className={clsx('editable-cell', className)}
			onDoubleClick={(e: MouseEvent<HTMLDivElement>) => {
				if (disabled) return;
				setEnableEditing(true);
			}}
			data={
				<Formik initialValues={{}} onSubmit={() => {}}>
					{enableEditing ? (
						<>{editComponent({ setEnableEditing })}</>
					) : (
						<div
							className={clsx('spaces', textClassName, {
								'pe-none': disabled,
							})}
						>
							{textValue}
						</div>
					)}
				</Formik>
			}
		/>
	);
};

export default memo(EditableCell);
